module.exports = __webpack_public_path__ + "img/student_23.a07d6e45.png";